import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { ErrorMsgEnum } from '@app/entities/enums/error/error-msg-enum';
import { DocumentUrl } from '@app/entities/models/ptrab/documents/document-url.model';
import { Document } from '@app/entities/models/ptrab/documents/document.model';

export interface DocumentsUseCases {
  error$: Observable<ErrorMsgEnum>;
  getDocuments(): Observable<Document[]>;
  getDocumentUrlById(documentId: string): Observable<DocumentUrl>;
  getOnBoardingDocumentUrlById(documentId: string): Observable<DocumentUrl>;
  getOnBoardingDocument(): Observable<Document[]>;
}

export const DOCUMENTS_USE_CASES = new InjectionToken<DocumentsUseCases>('DOCUMENTS_USE_CASES');
